const enum ContestStatusFilter {
  ACTIVE = 'ACTIVE',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  FINALIZED = 'FINALIZED',
}

export { ContestStatusFilter };
